(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('PhysicalFairEventVenueController', PhysicalFairEventVenueController)

    PhysicalFairEventVenueController.$inject = ['$uibModal', 'ExpoService', 'addresses'];


    function PhysicalFairEventVenueController($uibModal, ExpoService, addresses) {
        var vm = this;

        vm.queryFlag                    = false;
        vm.addresses                    = addresses;
        // vm.expotypes                    = [];
        // vm.selectExpos                  = selectExpos;
        vm.getByFilter                     = getByFilter;
        // vm.createExpo                   = createExpo;
        // vm.sendEmailTest                = sendEmailTest;
        // vm.deletePhysicalFair           = deletePhysicalFair;
        // vm.physicalFairSettingsStatus   = physicalFairSettingsStatus;
        // vm.changeAddress                = changeAddress;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        vm.form = {
            city: '',
            place: ''
        }

        function changeAddress() {
            if (vm.form.place.geometry !== undefined) {
                console.log(vm.form.place)
                vm.form.name = vm.form.place.name
                vm.form.address = vm.form.place.formatted_address
                vm.form.neighborhood = vm.form.place.address_components[1].long_name
                vm.form.zipcode = vm.form.place.address_components[5].long_name
                vm.form.website = vm.form.place.website
                vm.form.phone = vm.form.place.international_phone_number
                // console.log(vm.form.place.geometry.location.lat)
                // var latLng = vm.form.place.geometry.location.toJSON(); 
                // console.log(latLng)
                vm.form.latitude = vm.form.place.geometry.location.lat()
                vm.form.longitude = vm.form.place.geometry.location.lng()
            }
            
        }
        
        function activate() {
            vm.setPage(1);
            // vm.expos = expos;
            vm.addresses.unshift({id: -1, name: '--- All ---'});
            // vm.selectExpos();
            vm.getByFilter();

            // Prepare expos select
            // vm.exposSelect = [];
            // angular.copy(expos, vm.exposSelect);
            // vm.exposSelect.unshift({id: -1, name: '--- All ---'});
            vm.addressSelected                 = -1;
        }

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function selectExpos () {
            ExpoService.getExpos().then(function(response){
                vm.expos = response.data;
                vm.expos.unshift({id: -1, name: '--- All ---'});
            });
        }

        function getByFilter () {
            vm.queryFlag = false;
            let query = {};
            query['paginate'] = 20;
            query['page'] = vm.page;
            if(vm.addressSelected > 0) {
                query['id'] = vm.addressSelected;
            }
            ExpoService.getEventVenues(query).then(function(response){
                vm.queryFlag = true;
                vm.list = response.data.data;
                vm.totalItems = response.data.total;
                vm.itemsPerPage = response.data.per_page;
                vm.to = response.data.to;
                vm.setPage(response.data.current_page);
            });
        }

        function createExpo(virtualfair = null) {
            $uibModal.open({
                templateUrl: "templates/virtualfairs/settings/form/form.modal.html",
                controller: "VirtualFairSettingsFormController",
                controllerAs: "vm",
                resolve: {
                    virtualfair: () => {
                        return virtualfair;
                    },
                    expotypes: () => {
                        return vm.expotypes;
                    }
                },
            });
        }

        function sendEmailTest (virtualfair) {
            alertify.prompt('Email confirmation test', 'Who do you want to send this email to?', null,
                function(evt, value ){
                    if(value && value.length){
                        let data = {
                            id: virtualfair.id,
                            email: value
                        }
                    
                        VirtualFairService.sendEmailTest(data)
                        .then(function (response) {
                            if(!response.data.error) {
                                alertify.success('Email confirmation test sended!');
                            } else {
                                alertify.error(response.data.msg);
                            }
                        });
                    }
                },
                function(){
                    return true;
                });
        }

        function deletePhysicalFair (virtualfair) {
            if(virtualfair.pre_registrations.length == 0) {
                alertify.confirm(
                    'Delete Virtual Fair',
                    `Do you really want to delete this <strong>${virtualfair.name}</strong>?`,
                    function () {
                        VirtualFairService.deleteVirtualFair(virtualfair.id)
                            .then(function (response) {
                                if(!response.data.error) {
                                    vm.setPage(1);
                                    vm.getByFilter();
                                    alertify.success('Virtual event successfull deleted!');
                                } else {
                                    alertify.error(response.data.msg);
                                }
                            });
                    },
                    function () {
                        return true;
                    }
                );
            }
        }

        function physicalFairSettingsStatus (virtualfair) {
            alertify.confirm(
                'Open/Close Virtual Event',
                'Would you like to <strong>' + (virtualfair.show_to_customers == 0 ? 'OPEN' : 'CLOSE') + '</strong> this Virtual Event for registration of exhibitors?',
                function () {
                    VirtualFairService.virtualFairSettingsStatus(virtualfair.id)
                        .then(function (response) {
                            if(!response.data.error) {
                                virtualfair.show_to_customers = response.data.status;
                                alertify.success('Virtual event successfull updated!');
                            } else {
                                alertify.error(response.data.msg);
                            }
                        });
                },
                function () {
                    return true;
                }
            );
        }

        activate();
    }

})();